module.exports = __webpack_public_path__ + "img/9788952778505.9f3ae53a.jpg";